var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIonicIosChatboxes = function SvgIonicIosChatboxes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.998,
    height: 15.005,
    viewBox: "0 0 14.998 15.005",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-chatboxes",
    "data-name": "Icon ionic-ios-chatboxes",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_5",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 5",
    d: "M20.427,11.981H12.968a1.284,1.284,0,0,0-1.282,1.282v5.193a1.281,1.281,0,0,0,1.282,1.279h4.268a.368.368,0,0,1,.256.108l2.12,1.955c.118.114.313.067.313-.1V20c0-.2.128-.266.33-.266h.034a1.4,1.4,0,0,0,1.417-1.279v-5.19A1.277,1.277,0,0,0,20.427,11.981Z",
    transform: "translate(-7.708 -7.862)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_6",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 6",
    d: "M7.629,6.67H13.6v-2.2a1.1,1.1,0,0,0-1.1-1.1H4.472a1.1,1.1,0,0,0-1.1,1.1v5.56a1.1,1.1,0,0,0,1.1,1.1H6.529V7.767A1.1,1.1,0,0,1,7.629,6.67Z",
    transform: "translate(-3.375 -3.375)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIonicIosChatboxes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ionic-ios-chatboxes.912f1739.svg";
export { ForwardRef as ReactComponent };